type PaginationModel = {
  page: number
  pageSize: number
  total: number
  totalPages: number
}

type PageableModel<T> = PaginationModel & {
  items: T[]
}

export namespace Pagination {
  export const DEFAULT_PAGE = 1
  export const PAGE_PARAM_NAME = 'page'
  export const PAGE_SIZE_PARAM_NAME = 'pageSize'

  export type Params = {
    page: number
    pageSize?: number | null
  }

  export type Model = PaginationModel
  export type Pageable<T> = PageableModel<T>
}
